import { Link, useNavigate } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";
import DashboardEorder from "../../components/Dashboard/DashboardEorder";
import Dashboardfifth from "../../components/Dashboard/DashboardFifth";
import Dashboardfourth from "../../components/Dashboard/Dashboardfourth";
import EOrderDash from "../../components/Dashboard/EOrderDash";
import HomeDash from "../../components/Dashboard/HomeDash";
import DashboardAmount from "../../components/Dashboard/dashboardAmount";
import Dashboardthird from "../../components/Dashboard/dashboardthird";
import Navbar from "../../components/Navbar/Navbar";
import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/Loading";
import ShimmerLoader, { DashboardShimmer } from "../../loading";
import { Breadcrumb } from "antd";
import { routes } from "../../Routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PurchaseDash from "../../components/Dashboard/PurchaseDash";
import { URLS } from "../../API/API endpoints";
import axios from "axios";
import { getUserOnboarding } from "../../API  Functions/DashboardFunctions";
import IsAddProd from "../../assets/Dashboard/IsAddProd.svg";
import IsMachineCode from "../../assets/Dashboard/IsMachineCode.svg";
import IsCashierSetup from "../../assets/Dashboard/IsCashierSetup.svg";
import IsAddUser from "../../assets/Dashboard/IsAddUser.svg";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { LineChart } from "@mui/x-charts/LineChart";
import axiosInstance from "../../AxiosInstance";
import one from "../../assets/Order/one.svg";
import two from "../../assets/Order/two.svg";
import three from "../../assets/Order/three.svg";
import averageordervalue from "../../assets/Dashboard/averageordervalue.svg";
import posorders from "../../assets/Dashboard/posorders.svg";
import postotalsales from "../../assets/Dashboard/postotalsales.svg";
import totalcreditvalue from "../../assets/Dashboard/totalcreditvalue.svg";
import { PieChart } from "@mui/x-charts/PieChart";
import dayjs from "dayjs";
import "dayjs/locale/ar"; // Arabic locale

const OnlineDashboard = ({start, end, refreshKey }) => {
  const { t, i18n } = useTranslation();
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const [loading, setLoading] = useState(false);
  const [dashbaordData, setDashbaordData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    GetdashboardData();
  }, [start, end, refreshKey]);

  const GetdashboardData = async () => {
    let payload = {
      company_id: company_id,
      lang: i18n.language == "ar" ? "ar_001" : "en_US",
       start_date: start,
      end_date: end,
    };
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.ONLINE_DASHBOARD, payload);
      // console.log("DATA===>", response?.data);

      if (response?.data?.result) {
        setDashbaordData(response?.data?.result);
      } else {
        setDashbaordData({});
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const topProducts = dashbaordData?.top_products || [];
  const dataset = topProducts?.slice(0, 10).map((item) => ({
    unit_sold: item.units_sold,
    product: item.product_name,
    product: i18n.language === "ar" ? (item.product_name_ar || item.product_name) : item.product_name,

  }));

  const values = [
    {
      img: postotalsales,
      heading: t("Total Sales"),
      productsleft: `EGP ${dashbaordData?.online_orders_today?.sales
        ? dashbaordData?.online_orders_today?.sales?.toFixed(2)
        : "0"
        }`,
      bgcolor: "#DBFBDA6B",
      textcolor: "#059003",
      // subHeading: `(${t("Last 7 days")})`,
    },
    {
      img: posorders,
      heading: t("Orders"),
      productsleft: `${dashbaordData?.online_orders_today?.orders || "0"}`,
      bgcolor: "#2F80ED29",
      textcolor: "#2F80ED",
      // subHeading: `(${t("Today")})`, 
        action: () => navigate("/orders"),
    },
    {
      img: averageordervalue,
      heading: t("Average Order Value"),
      productsleft: `EGP ${dashbaordData?.last_7_days?.average_order_value
        ? dashbaordData?.last_7_days?.average_order_value?.toFixed(2)
        : "0"
        }`,
      bgcolor: "#FFE5CD85",
      textcolor: "#EB853C",
      // subHeading: `(${t("Last 7 days")})`,
    },
    {
      img: totalcreditvalue,
      heading: t("Pending COD Value"),
      productsleft: `EGP ${dashbaordData?.pending_cod_value
        ? dashbaordData?.pending_cod_value?.toFixed(2)
        : "0"
        }`,
      bgcolor: "#EB575729",
      textcolor: "#EB5757",
      //   wide: true,
    },
  ];

  const chartSetting = {
    yAxis: [
      {
        label: t("Units Sold"),
        labelStyle: {
          fontFamily: 'Cairo, sans-serif',
          fontWeight: 600, // optional
        },
      },
    ],
    margin: { left: 80, right: 70 }, // 👈 add space on the left'
    borderRadius: 7,
    series: [
      { dataKey: "unit_sold", label: t("Units Sold"), color: "#2F80ED" },
    ],
    height: 330,
    sx: {
      [`& .${axisClasses.directionY} .${axisClasses.label}`]: {
        transform: "translateX(-30px)",
      },
    },
  };

  const salesData = dashbaordData?.daily_online_sales || [];
  // Take last 14 entries
  const last14 = salesData.slice(-14);
  const xAxisData = last14.map((item) =>
    dayjs(item.order_date)
      .locale(i18n.language == "ar" ? "ar" : "en") // switch to Arabic
      .format("DD MMM")
  );
  const yAxisData = last14.map((item) => item.total_sales);

  const statusColors = {
    "In Processing": "#FFC107",
    "Order Completed": "#20C997",
    "Ready For Delivery": "#266EA8",
    "On the way": "#2F80ED",
    "Order Delivered": "#27AE60",
    "Order Pending": "#FFEB3B",
    cancel: "#EB5757",
  };
  const statusLabel = {
    "Order Pending": `${t("order_pending")}`,
    "In Processing": `${t("In Processing")}`,
    "Ready For Delivery": `${t("ready_for_delivery")}`,
    "On the way": `${t("Out For Delivery")}`,
    "Order Delivered": `${t("Order Delivered")}`,
    "Order Completed": `${t("Order Completed")}`,
    cancel: `${t("Order Cancelled")}`,
  };

  // Convert object → array for PieChart
  const excludedKeys = [
    "paid",
    "done",
    "Order Arrived",
    "Order Pickup",
    "Draft",
  ];

  const filteredEntries = Object.entries(
    dashbaordData?.order_status_breakdown ?? {}
  ).filter(([label]) => !excludedKeys.includes(label));

  // calculate total
  const total = filteredEntries.reduce((acc, [, value]) => acc + value, 0);

  const pieData = (() => {
    const allZero = filteredEntries.every(([_, value]) => value === 0);
    if (allZero) return [];

    return filteredEntries.map(([label, value], index) => {
      const percentage = ((value / total) * 100).toFixed(1); // keep 1 decimal
      return {
        id: index,
        value,
        label: statusLabel[label],
        percentage,
        color: statusColors[label] || "#ccc",
      };
    });
  })();

  const valueFormatter = (item) =>
    `${item?.percentage ? item?.percentage : "0"}% (${item?.value ? item?.value : "0"
    })`;
  const valueFormatterMethod = (item) =>
    `${item?.value ? item?.value : "0"}% (${item?.val ? item?.val : "0"})`;

 const orderPaymentPieData = (() => {
  const data = [
    {
      id: 0,
      value: dashbaordData?.payment_method_split?.cod?.percentage ?? 0,
      val: dashbaordData?.payment_method_split?.cod?.orders ?? 0,
      label: t("COD"),
      color: "#2F80ED",
    },
    {
      id: 1,
      value: dashbaordData?.payment_method_split?.bank?.percentage ?? 0,
      val: dashbaordData?.payment_method_split?.bank?.orders ?? 0,
      label: t("Bank"),
      color: "#F2994A",
    },
  ];

  return data.every((item) => item.value === 0) ? [] : data;
})();

  return (
    <>
      {/* {loading && <LoadingSpinner />} */}
      <div className="w-full flex flex-col md:h-full pb-2  bg-[#F6F7F9]">
        <div className="flex-grow  overflow-hidden ms-1 ">
          {loading ? (
            <div className=" mt-3 me-4">
              <DashboardShimmer />
            </div>
          ) : (
            <>
              <div
                className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 xl:grid-cols-4 me-4 mt-4`}
              >
                {Object.values(values).map((val, index) => (
                 <div
                    key={index}
                    className={`rounded-xl px-2 py-4 shadow-sm transition-transform transform ${val.action ? "hover:scale-[1.02] hover:shadow-lg cursor-pointer" : ""
                      }`}
                    style={{ backgroundColor: val.bgcolor }}
                    onClick={val.action}
                  >
                    <div className="flex items-center justify-between gap-3">
                      <div className="flex items-center gap-3">
                        <img src={val.img} alt="icon" className="w-10 h-10" />
                        <div className="flex flex-col">
                        <div className="flex flex-row items-center">
                            <p className="text-[13px] font-medium text-gray-700 truncate">
                              {val.heading}
                            </p>
                            <p className="text-[9px] font-medium text-[#111111B2] ps-1">
                              {val.subHeading}
                            </p>
                          </div>
                          <p
                            className="text-xl font-bold"
                            style={{ color: val.textcolor }}
                          >
                            {val.productsleft}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div
                dir="ltr"
                className={`flex justify-between gap-4 mt-4 ${i18n.language == "ar" ? "ps-4" : "pe-4"
                  }`}
              >
                <div className=" flex flex-col rounded-2xl bg-white border border-[#EDEEF1] px-5 py-4  w-6/12 justify-between min-h-[380px]">
                  <h3 className="font-bold mb-4  mt-2">{t("order_status")}</h3>
                  {pieData?.length > 0 ? (
                    <>
                      <PieChart
                        series={[
                          {
                            data: pieData,
                            arcLabel: (params) => `${params.percentage}%`, // show percentage
                            innerRadius: 60,
                            valueFormatter,
                          },
                        ]}
                        width={450}
                        height={210}
                        margin={{ left: -50 }}
                        slotProps={{
                          legend: {
                            direction: "column",
                            position: { vertical: "top", horizontal: "right" },
                            padding: 8,
                            itemMarkWidth: 25,
                            itemMarkHeight: 15,
                            labelStyle: {
                              fontFamily: 'Cairo, sans-serif', 
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#333",
                            },
                          },
                          pieArcLabel: {
                            style: {
                              fontSize: 12, // 👈 reduce arc label font size
                              fontWeight: 600,
                              fill: "#fff",
                            },
                          },
                        }}
                        sx={{
                          "& .MuiChartsArcLabel-root": {
                            fontSize: 10, // 👈 reduce font size here
                            fontWeight: 600,
                            fill: "#fff", // optional: white text for better contrast
                          },
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                </div>
                <div className=" flex flex-col rounded-2xl bg-white border border-[#EDEEF1] px-5 py-4  w-6/12 justify-between min-h-[380px]">
                  <h3 className="font-bold mb-4  mt-2">
                    {t("Payment Method Split")}
                  </h3>
                  {orderPaymentPieData?.length > 0 ? (
                    <>
                      <PieChart
                        series={[
                          {
                            data: orderPaymentPieData,
                            arcLabel: (params) => `${params?.value}%` ?? "",
                            innerRadius: 60,
                            valueFormatter: valueFormatterMethod,
                          },
                        ]}
                        width={400}
                        height={210}
                        slotProps={{
                          legend: {
                            direction: "column",
                            position: { vertical: "top", horizontal: "right" },
                            padding: 8,
                            itemMarkWidth: 25,
                            itemMarkHeight: 15,
                            labelStyle: {
                              fontFamily: 'Cairo, sans-serif', 
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#333",
                            },
                          },
                          pieArcLabel: {
                            style: {
                              fontSize: 12,
                              fontWeight: 600,
                              fill: "#fff",
                            },
                          },
                        }}
                        sx={{
                          "& .MuiChartsArcLabel-root": {
                            fontSize: 12,
                            fontWeight: 600,
                            fill: "#fff", // white for better contrast
                          },
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div
                dir="ltr"
                className={`flex justify-between gap-4 mt-4 ${i18n.language == "ar" ? "ps-4" : "pe-4"
                  }`}
              >
                <div className="rounded-2xl bg-white border border-[#EDEEF1] px-5 py-4 w-6/12 min-h-[380px]">
                  <h3 className="font-bold mb-4  mt-2">
                    {t("Daily Sales (14 Days)")}
                  </h3>
                  {yAxisData?.length > 0 ? (
                    <>
                      <LineChart
                        height={330}
                        xAxis={[
                          {
                            id: "days",
                            data: xAxisData,
                            scaleType: "point", // important when x values are strings
                          },
                        ]}
                        series={[
                          {
                            id: "Sales",
                            label: t("Daily Sales"),
                            data: yAxisData,
                            area: true,
                            color: "#1ABC9C",
                          },
                        ]}
                        margin={{ left: 80 }} // 👈 add space on the left
                        yAxis={[
                          {
                            label: t("Sales Value (EGP)"),
                            labelStyle: {
                              fontFamily: 'Cairo, sans-serif',
                              fontWeight: 600, // optional
                            },
                          },
                        ]}
                        sx={{
                          [`& .${axisClasses.directionY} .${axisClasses.label}`]:
                          {
                            transform: "translateX(-30px)",
                          },
                        }}
                        slotProps={{
                          legend: {
                            direction: "column", // row | column
                            position: { vertical: "top", horizontal: "right" }, // top, bottom, left, right
                            padding: 0,
                            itemMarkWidth: 25, // size of color box
                            itemMarkHeight: 15,
                            labelStyle: {
                              fontFamily: 'Cairo, sans-serif', 
                              marginLeft: 5,
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#333",
                            },
                          },
                        }}
                      />
                      <p
                        style={{ fontWeight: 600 }}
                        className="font-medium text-[#111111] text-sm ms-64 -mt-4"
                      >
                        {t("Date")}
                      </p>
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                </div>
                <div className="rounded-2xl bg-white border border-[#EDEEF1] px-5 py-4 w-6/12 min-h-[380px]">
                  <h3 className="font-bold mb-4  mt-2">
                    {t("Top 10 Selling Products")}
                  </h3>
                  {dataset?.length > 0 ? (
                    <>
                      <BarChart
                        dataset={dataset}
                        xAxis={[
                          {
                            scaleType: "band",
                            dataKey: "product",
                            tickPlacement: "middle",
                            categoryGapRatio: 0.4,
                          },
                        ]}
                        {...chartSetting}
                        slotProps={{
                          legend: {
                            direction: "column", // row | column
                            position: { vertical: "top", horizontal: "right" }, // top, bottom, left, right
                            padding: 0,
                            itemMarkWidth: 25, // size of color box
                            itemMarkHeight: 15,
                            labelStyle: {
                              fontFamily: 'Cairo, sans-serif', 
                              marginLeft: 5,
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#333",
                            },
                          },
                        }}
                      />
                       <p
                    style={{ fontWeight: 600 }}
                    className="font-medium text-[#111111] text-sm ms-64 -mt-4"
                  >
                    {t("products")}
                  </p>
                    </>
                  ) : (
                    <>
                      <div className=" text-sm flex justify-center h-full items-center">
                        <p>{t("No data available")}</p>
                      </div>
                    </>
                  )}
                 
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default OnlineDashboard;
